import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

import { DASHBOARD_TEXT } from './dashboardText';

interface ComponentProps {
  /** Unique on the page. */
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/**
 * Show Workers with No CM Hours (TAV-3482), in the workers full table's toolbar only: whether case managers with no
 * care management hours are listed with the workers. Off by default. The rows are already loaded, so it changes the
 * table at once with no request.
 */
export const NoCmHoursCheckbox: React.FC<ComponentProps> = ({ id, checked, onChange }) => (
  <FormGroup check className="mb-0">
    <Input
      id={id}
      type="checkbox"
      checked={checked}
      onChange={(event) => onChange(event.target.checked)}
      data-cy={id}
    />
    <Label check for={id}>
      {DASHBOARD_TEXT.workers.noCmHours}
    </Label>
  </FormGroup>
);
